module.exports = __webpack_public_path__ + "img/ouboli.7476afb3.png";